export default __webpack_public_path__ + "static/media/tete3.4083ea22.png";